import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class FcmMessagingService {
  private countreset= new BehaviorSubject<any>(null);

  constructor(private afMessaging: AngularFireMessaging, private http: HttpClient, public environment: EnvService) {
  }

  getNotificationFlag(){
    return this.http.get(`${this.environment.adminUrl}business/api/setup/getNotificationflag`);
  }

  requestPermission(): Observable<any> {
    return this.afMessaging.requestPermission;
  }

  receiveMessage(): Observable<any> {
    return this.afMessaging.messages;
  }

  getToken(): Observable<string> {
    return this.afMessaging.getToken;
  }

  getNotificationSet(request) {
    return this.http.get<any>(`${this.environment.appservice_url}/notificationsettings/list/` + request.guid + "/" + request.uid);
  }
  updateNotificationSettings(request) {
    return this.http.post<any>(`${this.environment.appservice_url}/notification/setting/save`, request,{ headers: { hideLoader: 'true' } });
  }

  getNotiHistory(request) {
    return this.http.get<any>(`${this.environment.notification_url}/getNotificationHistory?guid=` + request.guid + '&uid=' + request.uid,{ headers: { hideLoader: 'true' }});
  }
  updateFcmToken(request) {
    localStorage.setItem("fcmtoken", request.device_fcm_token);
    return this.http.post<any>(`${this.environment.adminUrl}user/api/user/updatefcmtoken`, request,{ headers: { hideLoader: 'true' } });
  }

  deleteToken(): Observable<void> {
    return new Observable(observer => {
      const token = localStorage.getItem("fcmtoken");
      this.afMessaging.deleteToken(token).subscribe({
        next: () => {
          console.log('FCM Token deleted');
          observer.next();
        },
        error: (err) => {
          console.error('Error deleting token:', err);
          observer.error(err);
        }
      });
    });
  }

  updateSeen(request) {
    return this.http.post<any>(`${this.environment.notification_url}/updateNotificationClickedHistory`, request);
  }

  markAllRead(request) {
    return this.http.post<any>(`${this.environment.notification_url}/markAllNotificatonsAsRead`, request);
  }

  getNotiCount(request) {
    return this.http.get<any>(`${this.environment.notification_url}/newNotificationCount?guid=` + request.guid + '&uid=' + request.uid,{ headers: { hideLoader: 'true' } });
  }

  updateBellicon(request){
    return this.http.post<any>(`${this.environment.notification_url}/updateNotificationSeen`, request);
  }

  setCountreset(countreset:any){
    this.countreset.next(countreset);
  }

  getCountreset():Observable<any>{
    return this.countreset.asObservable();
  }
}
